import { useEffect, useRef } from 'react';

/**
 * Hook to automatically cancel async task with abort controller
 * @returns abort controller signal
 */
const useAbortControllerSignal = () => {
  const ref = useRef<AbortController>(new AbortController());

  useEffect(() => {
    const abortController = ref.current;
    return () => {
      abortController.abort();
    };
  }, []);

  return ref.current.signal;
};

export default useAbortControllerSignal;
